import { Component, inject, Input } from '@angular/core';
import { SmartCartBlockType } from '../../smart-cart-block.model';
import { SmartCartPreviewStateService } from '../smart-cart-preview-state.service';
import {
  AnnouncementBarSettings,
  CartItemsSettings,
  CartSubtotalSettings,
  CheckoutAreaSettings,
  DigitalUpsellSettings,
  DiscountCodesSettings,
  GlobalButtonDesign,
  GLOBAL_BUTTON_DESIGN_DEFAULT,
  GoalsProgressBarSettings,
  SmartCartPreviewConfig,
  TopBarSettings,
  UpsellItemsSettings,
} from '../widget-previews/widget-preview.types';

const HIDE_WHEN_EMPTY: readonly SmartCartBlockType[] = [
  SmartCartBlockType.DISCOUNT_CODES,
  SmartCartBlockType.CART_SUBTOTAL,
  SmartCartBlockType.CHECKOUT_AREA,
];

@Component({
  selector: 'smart-cart-preview-drawer',
  templateUrl: './smart-cart-preview-drawer.component.html',
  styleUrls: ['./smart-cart-preview-drawer.component.scss'],
  standalone: false,
})
export class SmartCartPreviewDrawerComponent {
  @Input() config: SmartCartPreviewConfig | null = null;

  readonly SmartCartBlockType = SmartCartBlockType;
  readonly showEmptyCart = inject(SmartCartPreviewStateService).showEmptyCart;

  isHiddenOnEmpty(type: SmartCartBlockType): boolean {
    return this.showEmptyCart() && HIDE_WHEN_EMPTY.includes(type);
  }

  topBarSettings(settings: Record<string, unknown>): TopBarSettings {
    return settings as unknown as TopBarSettings;
  }

  cartItemsSettings(settings: Record<string, unknown>): CartItemsSettings {
    return settings as unknown as CartItemsSettings;
  }

  cartSubtotalSettings(settings: Record<string, unknown>): CartSubtotalSettings {
    return settings as unknown as CartSubtotalSettings;
  }

  checkoutAreaSettings(settings: Record<string, unknown>): CheckoutAreaSettings {
    return settings as unknown as CheckoutAreaSettings;
  }

  discountCodesSettings(settings: Record<string, unknown>): DiscountCodesSettings {
    return settings as unknown as DiscountCodesSettings;
  }

  announcementBarSettings(settings: Record<string, unknown>): AnnouncementBarSettings {
    return settings as unknown as AnnouncementBarSettings;
  }

  goalsSettings(settings: Record<string, unknown>): GoalsProgressBarSettings {
    return settings as unknown as GoalsProgressBarSettings;
  }

  upsellSettings(settings: Record<string, unknown>): UpsellItemsSettings {
    return settings as unknown as UpsellItemsSettings;
  }

  digitalUpsellSettings(settings: Record<string, unknown>): DigitalUpsellSettings {
    return settings as unknown as DigitalUpsellSettings;
  }

  globalButtonDesign(): GlobalButtonDesign {
    const fromConfig = this.config?.global?.['buttonDesign'] as Partial<GlobalButtonDesign> | undefined;
    return { ...GLOBAL_BUTTON_DESIGN_DEFAULT, ...(fromConfig ?? {}) };
  }
}
